export default __webpack_public_path__ + "static/raise-7b922dfcee55226ca16c353b975e0a5e.png";